<lex-doc-viewer-coding-section panelId="expandable-coding-panel-{{customField?.fieldId}}"
                               *inRole="[roles.StandardFeatureSet, roles.DocReviewFeatureSet]">
  <div coding-section-title>{{customField.displayTitle}}</div>
  <div style="display: flex; flex-direction: column; margin: 10px 0; gap: 10px;" [formGroup]="codingSectionForm"
       *ngIf="codingSectionForm">
    <ng-container *ngFor="let child of children">
      <lex-text-input *ngIf="child.type === 1" label="{{child.displayTitle}}"
                      [formControl]="codingSectionForm.get(child.fieldId)" [id]="child.fieldId" maxlength="1024"></lex-text-input>
      <lex-checkbox *ngIf="child.type === 2 || child.type === 3" [id]="child.fieldId" label="{{child.displayTitle}}"
                    [formControl]="codingSectionForm.get(child.fieldId)"></lex-checkbox>
    </ng-container>
  </div>
</lex-doc-viewer-coding-section>
